import { render, staticRenderFns } from "./MenuMainModal.vue?vue&type=template&id=034429ed&"
import script from "./MenuMainModal.vue?vue&type=script&lang=js&"
export * from "./MenuMainModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuMainModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports